import { defineStore } from 'pinia'
import { useState } from '../ui/state'
import Actions from './actions'

export { type UiState } from './state'

export const useUiStore = defineStore('ui', {
  state: useState,
  actions: { ...Actions },
})

export type UiStoreContext = ReturnType<typeof useUiStore>